import { render, staticRenderFns } from "./message-dialog-new.vue?vue&type=template&id=136181b8&scoped=true"
import script from "./message-dialog-new.vue?vue&type=script&lang=ts"
export * from "./message-dialog-new.vue?vue&type=script&lang=ts"
import style0 from "./message-dialog-new.vue?vue&type=style&index=0&id=136181b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136181b8",
  null
  
)

export default component.exports